export const Data = [
  {
    question: 'Нужно ли открыть счет в Jusan Bank',
    answer:
    'Вам нужно только зарегистрироваться в приложении Jusan и перейти в раздел “Инвестиции” для открытия инвестиционного счета. После успешной регистрации в разделе Инвестиции надмите на кнопку Junior, чтобы открыть счет для вашего ребенка. Далее следуйте инструкции на экране  Для открытия счета ребенку, нужно, чтобы у него был свой номер мобильного телефона и мобильное устройство для установки отдельного приложения Jusan Junior.',
  },
  {
    question: 'Чем Jusan Junior отличается от Jusan Инвестиций?',
    answer:
      'Приложение Jusan Junior разработано специально для детей. Ребенок может самостоятельно инвестироваться в ценные бумаги и обучаться инвестированию в Академии для детей. Счет Junior привязан к счету родителя, поэтому взрослый в любой момент может проверять операции ребенка, устанавливать лимиты и пополнять счет через мобильное приложение.',
  },
  {
    question: 'К каким рынкам есть доступ у ребенка?',
    answer:
      'На данный момент в приложении Jusan Junior можно торговать любыми акциями из списка KASE Global, а также акциями казахстанских компаний на казахстанской фондовой бирже KASE',
  },
  {
    question: 'Со скольки лет ребенок может открыть счет в Jusan Junior',
    answer:
      'На данный момент инвестировать через приложение Jusan Junior можно с 10 до 16 лет',
  },
  {
    question: 'Ребенок разве готов к таким рискам?',
    answer:
      'В приложении Jusan Junior ребенок является инициатором сделок, в то время как вы, как владелец счета, совершаете сделку по покупке или продаже ценной бумаге.',
  },
  {
    question: 'Что будет, если ребенок потратит все деньги?',
    answer:
      'Чтобы избежать ошибочных покупок, вы можете поставить лимит на количество или на сумму сделок в день, неделю или месяц. Ваш ребенок не сможет потратить больше денег, чем вы ему отправите. Любые купленные бумаги можно продать по более высокой цене, когда рыночная стоимость этой акции, ПИФа или ETF увеличится. То же самое, что и с недвижимостью или обменным курсом валют.',
  },
];
